import React from 'react';
import PropTypes from 'prop-types';
import { H3, Paragraph } from 'components/core/Typography';
import { StorageUnitCard } from 'components/molecules';
import './StorageUnitChart.scss';

export function StorageUnitChart({ data, headingLevel }) {
	return (
		<div className="storage-chart-container">
			<div className="main-content">
				<div className="header-section">
					<H3
						className="header-title"
						typographyComponent={headingLevel}
					>
						{data.title}
					</H3>
					<Paragraph className="header-description">
						{data.description}
					</Paragraph>
				</div>

				<div className="storage-cards-wrapper">
					<div
						className={`storage-cards-grid cols-${data.units.length}`}
					>
						{data.units.map((unit) => (
							<StorageUnitCard
								key={unit.id}
								{...unit}
							/>
						))}
					</div>
					<div
						aria-hidden="true"
						className="storage-cards-border"
					/>
				</div>
			</div>
		</div>
	);
}

StorageUnitChart.propTypes = {
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		units: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.string.isRequired,
				size: PropTypes.string.isRequired,
				sqFt: PropTypes.string.isRequired,
				cuFt: PropTypes.string,
				looksLike: PropTypes.string.isRequired,
				whatWillFit: PropTypes.string.isRequired,
				illustration: PropTypes.string.isRequired,
			}),
		).isRequired,
	}).isRequired,
	headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};

StorageUnitChart.defaultProps = {
	headingLevel: 'h3',
};

export default StorageUnitChart;
